<template>
  <div class="header-container" :class="{ 'scrolled': isScrolled }">
    <div class="logo" @click="goToHome" style="cursor: pointer;">
      <img src="@/assets/slogen-logo3.png" alt="星栖宠物">
      <!-- <span>Starest🌟星栖宠物</span> -->
    </div>
    
    <!-- 修改为下拉菜单按钮 -->
    <el-dropdown trigger="click" class="menu-dropdown" @command="handleSelect">
      <div class="menu-toggle">
        <el-icon style="color: white;"><MoreFilled /></el-icon>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="/">首页</el-dropdown-item>
          <el-dropdown-item command="/about">关于星栖</el-dropdown-item>
          <el-dropdown-item command="/services">星栖服务</el-dropdown-item>
          <el-dropdown-item command="/process">服务流程</el-dropdown-item>
          <el-dropdown-item command="/products">纪念品</el-dropdown-item>
          <el-dropdown-item command="/cemetery">虚拟墓地</el-dropdown-item>
          <el-dropdown-item command="/articles">宠物知识</el-dropdown-item>
          <!-- <el-dropdown-item command="/stores">门店列表</el-dropdown-item> -->
          <el-dropdown-item command="/contact">联系我们</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <el-menu
      mode="horizontal"
      :router="true"
      :default-active="activeIndex"
      class="nav-menu">
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/about">关于我们</el-menu-item>
      <el-menu-item index="/services">星栖服务</el-menu-item>
      <el-menu-item index="/process">服务流程</el-menu-item>
      <el-menu-item index="/products">纪念品</el-menu-item>
      <el-menu-item index="/cemetery">虚拟墓地</el-menu-item>
      <el-menu-item index="/articles">宠物知识</el-menu-item>
      <!-- <el-menu-item index="/stores">门店列表</el-menu-item> -->
      <el-menu-item index="/contact">联系我们</el-menu-item>
    </el-menu>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { MoreFilled } from '@element-plus/icons-vue'

const route = useRoute()
const router = useRouter()
const activeIndex = ref(route.path)
const isScrolled = ref(false)

// 监听路由变化
watch(() => route.path, (newPath) => {
  activeIndex.value = newPath
})

// 添加跳转到主页的方法
const goToHome = () => {
  window.location.href = '/'
  // router.push('/')
  // activeIndex.value = '/'  // 添加这行，更新激活的导航项
}

// 处理滚动事件
const handleScroll = () => {
  isScrolled.value = window.scrollY > 0
}

// 组件挂载时添加滚动监听
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

// 组件卸载时移除滚动监听
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

const handleSelect = (key) => {
  activeIndex.value = key
  router.push(key)
}
</script>

<style scoped>
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  background: transparent;  /* 初始状态完全透明 */
  box-shadow: none;  /* 初始状态无阴影 */
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;  /* 添加过渡效果 */
}

.header-container.scrolled {
  background: #000000dd;  /* 滚动时的背景色 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);  /* 滚动时添加阴影 */
}

/* 删除未使用的 logo 相关样式，因为已经使用了图片 */
.logo {
  display: flex;
  align-items: center;
}

.logo span {
  font-size: 30px;
  font-weight: bold;
  color: #eaad35;
}

.nav-menu {
  background: transparent;
  border: none;
  flex: 1;  /* 添加这行，让导航菜单占据剩余空间 */
  display: flex;  /* 添加这行，使用flex布局 */
  justify-content: flex-end;  /* 添加这行，使菜单项靠右对齐 */
  border-bottom: 0px solid transparent !important;  /* 默认边框透明 */;
 
}

.nav-menu .el-menu-item {
  padding: 0 15px;
  font-size: 15px;
  color: white;
  background-color: transparent !important;  /* 确保背景始终透明 */
}

:deep(.el-menu--horizontal > .el-menu-item) {
  border-bottom: 0px solid transparent;
}

:deep(.el-menu--horizontal > .el-menu-item.is-active) {
  border-bottom: 2px solid #eaad35;
  color: #eaad35!important;
  background-color: transparent !important;  /* 激活状态背景透明 */
}

:deep(.el-menu--horizontal > .el-menu-item:not(.is-active):hover) {
  color: #eaad35;
  background-color: transparent !important;  /* 悬停状态背景透明 */
}

/* 移除焦点状态的背景色 */
:deep(.el-menu--horizontal > .el-menu-item:focus) {
  background-color: transparent !important;
  color: #eaad35;
}

:deep(.el-menu--horizontal > .el-menu-item.is-active::after) {
  background-color: #eaad35;  /* 确保下划线颜色一致 */
}

.menu-dropdown {
  display: none;
}

@media screen and (max-width: 768px) {
  .header-container {
    padding: 0 20px;
    height: 60px;
    position: relative;
  }
  
  .logo {
    margin: 0;
  }

  .nav-menu {
    display: none;  /* 在移动端隐藏原菜单 */
  }

  .menu-dropdown {
    display: block;
  }

  .menu-toggle {
    cursor: pointer;
    font-size: 24px;
    color: #333;
  }
  /* .el-dropdown-menu{
    width: 200px;
  } */

  :deep(.el-dropdown-menu__item) {
    text-align: center;
    color: #333;
    font-size: 15px;
    padding: 12px 20px;
  }

  :deep(.el-dropdown-menu__item:hover) {
    color: #eaad35;
    background-color: transparent !important;
    /* background-color: rgba(234, 173, 53, 0.1); */
  }

  :deep(.el-dropdown-menu__item.is-active) {
    color: #eaad35;
    background-color: transparent;
    /* background-color: rgba(234, 173, 53, 0.1); */
  }
}
</style>